import type { IModelConnection } from "@itwin/core-frontend";
import { QueryBinder, QueryRowFormat } from "@itwin/core-common";
import { Quantity } from "../../../domain/contracts/Quantity";
import { DOTPayItemIndex } from "./dotPayItemQuery";

const DOTPAYITEM_SCHEMA =
  "DgnCustomItemTypes_DOT_DigitalAssetMetadata";

  function buildQuantityByElementQuery(index: DOTPayItemIndex): string {
  if (index < 1 || index > 5) {
    throw new Error(`Invalid DOT_PayItem index: ${index}`);
  }

  return `
    SELECT
      p.Quantity.Method                AS Method,
      p.Quantity.Description           AS Description,
      p.Quantity.FactorItem            AS FactorItem,
      p.Quantity.FactorUser            AS FactorUser,
      p.Quantity.Factor                AS Factor,
      p.Quantity.Override              AS Override,
      p.Quantity.CompQuantity          AS CompQuantity,
      p.Quantity.RoundingConservative  AS RoundingConservative,
      p.Quantity.RoundingIncrement     AS RoundingIncrement,
      p.Quantity.RoundingPrecision     AS RoundingPrecision,
      p.Quantity.ItemQuantity          AS ItemQuantity
    FROM ${DOTPAYITEM_SCHEMA}.DOT_PayItem${index}ElementAspect p
    WHERE p.Element.Id = ?
  `;
  }

export async function queryQuantityForElement(
  iModel: IModelConnection,
  elementId: string,
  index: DOTPayItemIndex,
): Promise<Quantity | undefined> {
  const bindings = QueryBinder.from([elementId]);

  const reader = iModel.createQueryReader(
    buildQuantityByElementQuery(index),
    bindings,
    { rowFormat: QueryRowFormat.UseECSqlPropertyNames }
  );

  for await (const row of reader) {
    // Convert to a plain object with the aliases above as keys
    const plain = row.toRow() as any;
    const quantity = Quantity.fromObject(plain);
    return quantity;
  }

  // No Quantity struct for that element
  return undefined;
}
